(() => {
  if (window.__CART_CHANGE_FIX_INSTALLED__) return;
  window.__CART_CHANGE_FIX_INSTALLED__ = true;

  const DEBUG = true;

  function log(...args) {
    if (DEBUG) console.log('[cart-change-fix]', ...args);
  }

  function getPathFromUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return String(url || '');
    }
  }

  function isCartChangeRequest(url) {
    const path = getPathFromUrl(url);
    return path.includes('/cart/change');
  }

  function scanCartRows() {
    const rows = Array.from(document.querySelectorAll('[data-line-key]'));
    const byLine = new Map();
    const byVariant = new Map();

    rows.forEach((row, index) => {
      const key = row.getAttribute('data-line-key');
      if (!key) return;

      const lineAttr =
        row.getAttribute('data-line') ||
        row.getAttribute('data-line-index') ||
        row.dataset.line ||
        '';

      const line = String(parseInt(lineAttr, 10) || (index + 1));
      byLine.set(line, key);

      const variantId =
        row.getAttribute('data-variant-id') ||
        row.dataset.variantId ||
        '';

      if (variantId) {
        byVariant.set(String(variantId), key);
      }
    });

    return { byLine, byVariant };
  }

  function rewriteCartChangePayload(payload) {
    if (!payload || payload.id || payload.line == null) return payload;

    const lineRaw = String(payload.line);
    const maps = scanCartRows();

    let lineKey = maps.byLine.get(lineRaw);

    if (!lineKey) {
      lineKey = maps.byVariant.get(lineRaw);
    }

    if (!lineKey) {
      log('Nisam nasao lineKey za payload.line =', lineRaw, payload);
      return payload;
    }

    const next = { ...payload, id: lineKey };
    delete next.line;

    log('Rewrite payload:', payload, '=>', next);
    return next;
  }

  function patchFetch() {
    const nativeFetch = window.fetch;
    if (!nativeFetch) return;

    window.fetch = function patchedFetch(input, init) {
      try {
        const url = typeof input === 'string' ? input : input?.url;
        if (!isCartChangeRequest(url)) {
          return nativeFetch.apply(this, arguments);
        }

        if (!init || !init.body) {
          return nativeFetch.apply(this, arguments);
        }

        const nextInit = { ...init };

        if (typeof nextInit.body === 'string') {
          try {
            const parsed = JSON.parse(nextInit.body);
            const rewritten = rewriteCartChangePayload(parsed);
            nextInit.body = JSON.stringify(rewritten);
            return nativeFetch.call(this, input, nextInit);
          } catch (e) {
            try {
              const params = new URLSearchParams(nextInit.body);
              const obj = Object.fromEntries(params.entries());
              const rewritten = rewriteCartChangePayload(obj);

              const nextParams = new URLSearchParams();
              Object.entries(rewritten).forEach(([k, v]) => {
                if (v != null) nextParams.set(k, String(v));
              });

              nextInit.body = nextParams.toString();
              return nativeFetch.call(this, input, nextInit);
            } catch (e2) {
              return nativeFetch.apply(this, arguments);
            }
          }
        }

        // FormData body
        if (window.FormData && nextInit.body instanceof FormData) {
          const fd = nextInit.body;
          const obj = {};
          fd.forEach((value, key) => {
            obj[key] = value;
          });

          const rewritten = rewriteCartChangePayload(obj);
          if (rewritten !== obj) {
            const nextFd = new FormData();
            Object.entries(rewritten).forEach(([k, v]) => {
              if (v != null) nextFd.append(k, v);
            });
            nextInit.body = nextFd;
          }

          return nativeFetch.call(this, input, nextInit);
        }

        // URLSearchParams body
        if (window.URLSearchParams && nextInit.body instanceof URLSearchParams) {
          const obj = Object.fromEntries(nextInit.body.entries());
          const rewritten = rewriteCartChangePayload(obj);

          const nextParams = new URLSearchParams();
          Object.entries(rewritten).forEach(([k, v]) => {
            if (v != null) nextParams.set(k, String(v));
          });

          nextInit.body = nextParams;
          return nativeFetch.call(this, input, nextInit);
        }

        return nativeFetch.apply(this, arguments);
      } catch (err) {
        console.error('[cart-change-fix] fetch patch error:', err);
        return nativeFetch.apply(this, arguments);
      }
    };

    log('fetch patched');
  }

  function bindAtcDelegationDebug() {
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        log('ATC form submit caught via delegation', form);
      },
      true
    );
  }

  patchFetch();
  bindAtcDelegationDebug();
})();